import { render, staticRenderFns } from "./Directs.vue?vue&type=template&id=66a3cf2d"
import script from "./Directs.vue?vue&type=script&lang=js"
export * from "./Directs.vue?vue&type=script&lang=js"
import style0 from "./Directs.vue?vue&type=style&index=0&id=66a3cf2d&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports